import { lazy } from 'react'
import EValuePickerType from '../../types/EValuePickerType'

const SkillPicker = lazy(() => import('../../../value-picker-components/components/SkillPicker'))
const TextPicker = lazy(() => import('../../../value-picker-components/components/TextPicker'))
const TogglePicker = lazy(() => import('../../../value-picker-components/components/TogglePicker'))
const FilePicker = lazy(() => import('../../../value-picker-components/components/FilePicker'))
const SingleDayPicker = lazy(() => import('../../../value-picker-components/components/SingleDayPicker'))
const DynamicDataPicker = lazy(() => import('../../../value-picker-components/components/DynamicDataPicker'))
const ExternalIdentifierValuePicker = lazy(
    () => import('../../../value-picker-components/components/ExternalIdentifierValuePicker')
)
const NumberPicker = lazy(() => import('../../../value-picker-components/components/NumberPicker'))
const LinkPicker = lazy(() => import('../../../value-picker-components/components/LinkPicker'))
const TextSearch = lazy(() => import('../../../value-picker-components/components/TextSearchPicker/TextSearchPicker'))
const EventReservationRestrictionsPicker = lazy(
    () => import('../../../value-picker-components/components/EventReservationRestrictionsPicker')
)
const CheckboxPicker = lazy(() => import('../../../value-picker-components/components/CheckboxPicker'))
const ToggleButton = lazy(() => import('../../../value-picker-components/components/ToggleButtonPicker'))
const TimeRangeChip = lazy(() => import('../../../value-picker-components/components/TimeRangeChipPicker'))
const DateRangeV2 = lazy(() => import('../../../value-picker-components/components/DateRangeV2Picker'))

export const valuePickerMap = {
    [EValuePickerType.Hidden]: null,
    [EValuePickerType.DynamicData]: DynamicDataPicker,
    [EValuePickerType.FilePicker]: FilePicker,
    [EValuePickerType.ExternalIdentifierValuePicker]: ExternalIdentifierValuePicker,
    [EValuePickerType.NumberPicker]: NumberPicker,
    [EValuePickerType.SingleDayPicker]: SingleDayPicker,
    [EValuePickerType.SkillPicker]: SkillPicker,
    [EValuePickerType.TextPicker]: TextPicker,
    [EValuePickerType.Toggle]: TogglePicker,
    [EValuePickerType.LinkPicker]: LinkPicker,
    [EValuePickerType.TextSearch]: TextSearch,
    [EValuePickerType.EventReservationRestrictionRulePicker]: EventReservationRestrictionsPicker,
    [EValuePickerType.CheckboxPicker]: CheckboxPicker,
    [EValuePickerType.ToggleButton]: ToggleButton,
    [EValuePickerType.TimeRangeChip]: TimeRangeChip,
    [EValuePickerType.DateRangeV2]: DateRangeV2,
}

export type ValuePickerKey = keyof typeof valuePickerMap
